// extracted by mini-css-extract-plugin
export default {"warning_container":"upload_warning_container__U3NSY","donwload_container":"upload_donwload_container__yxycS","input_file":"upload_input_file__kaHyd"};